import React, { useEffect } from "react"
import { Phone } from "@phosphor-icons/react"
import { useCallStore } from "../../../stores"
import { playSound } from "../../../lib/twilio"
import { dismissIncomingCallAlert } from "../../../lib/twilio/incoming-call-alerts"

interface IncomingStateProps {
  collapsed?: boolean
}

export function IncomingState({ collapsed }: IncomingStateProps) {
  const { incomingCall } = useCallStore()

  // Play ringtone periodically
  useEffect(() => {
    if (!incomingCall) return

    playSound()
    const interval = setInterval(() => {
      playSound()
    }, 2500)

    return () => clearInterval(interval)
  }, [incomingCall])

  // Dismiss browser notification and title flash on unmount
  useEffect(() => {
    return () => {
      dismissIncomingCallAlert()
    }
  }, [])

  if (!incomingCall) return null

  return (
    <div className="py-3 bg-[#0d1f2d] animate-incoming-pulse">
      <div className="flex flex-col items-center">
        <div className="relative">
          <Phone className="h-6 w-6 text-white animate-bounce" />
        </div>
        {!collapsed && (
          <span className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-white/80">
            Incoming Call
          </span>
        )}
      </div>
    </div>
  )
}
